import LegacyForwardComponent from './index.jsx';
export default LegacyForwardComponent;
